import $ from 'jquery';
import * as select2Module from 'select2/dist/js/select2.full.js';

// Register select2 as a jQuery plugin ($.fn.select2). Single source of truth —
// other modules can call $('...').select2(...) without re-importing the factory.
//
// Why the namespace import gymnastics: select2's UMD wrapper does
// `module.exports = function(root, jQuery){...}`. Rollup's strict ESM analyzer
// won't synthesize a `default` export from that shape, so
// `import select2 from 'select2'` fails the production build. Pulling the
// namespace and reaching through .default (with a fallback for CJS interop)
// works under both vite dev (esbuild) and vite build (rollup).
const select2 = select2Module.default || select2Module;
select2(window, $);
